module.exports = __webpack_public_path__ + "img/logo.098e32f3.png";